
<!-- 根据区域检索摄像头 -->
<template>
  <div class="app-area-list">
    <div class="search-box">
      <el-input
        v-model="searchDevice"
        clearable
        prefix-icon="el-icon-search"
        placeholder="请输入"
      >
      </el-input>
    </div>
    <div class="area-container" ondragstart="return false">
      <el-scrollbar ref="scrollBar" class="scroll-bar">
        <el-tree
          class="full-height"
          ref="appDeviceGroupTree"
          :data="cameraTree"
          node-key="id"
          :props="defaultProps"
          :show-checkbox="multiCheck"
          highlight-current
          :default-expanded-keys="expandedKeys"
          :filter-node-method="filterNode"
          @node-click="getCheckNode"
        >
          <div
            unselectable="on"
            onselectstart="return false;"
            style="-moz-user-select: none"
            class="node"
            :title="data.name"
            slot-scope="{ data }"
            :class="[
              {
                'out-line':
                  parseInt(data.status) !== 1 && data.nodeType === 'device',
              },
              data.color,
            ]"
          >
            <i
              v-show="data.nodeType === 'device'"
              :style="{ color: data.color }"
              class="iconfont-lunan icon-lunan-shexiangtou"
            ></i>
            <span
              style="
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
              "
              >{{ data.name }}</span
            >
          </div>
        </el-tree>
      </el-scrollbar>
    </div>
  </div>
</template>
  <script>
import { api } from "../api";
export default {
  props: {
    multiCheck: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    searchDevice: {
      handler(val) {
        this.$refs.appDeviceGroupTree.filter(val);
      },
    },
  },
  data() {
    return {
      cameraTree: [],
      defaultProps: {
        children: "children",
        label: "name",
        id: "id",
      },
      searchDevice: "",
      checkCameraData: {},
      searchDeviceChange: false,
      // 默认展开的数组
      expandedKeys: [],
    };
  },
  mounted() {
    this.queryDevice();
  },
  methods: {
    // 单击
    getCheckNode(nodeData) {
      console.log(nodeData, "=nodeData");
      this.checkCameraData = { ...nodeData };
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },

    // 查询区域树
    queryDevice() {
      let url = api.bms.queryCameraList;
      let params = {
        deviceType: 10,
      };
      this.$fetch(url, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          let result = response.returnObj;
          this.expandedKeys = [result[0].id]; //默认展开第一级
          this.cameraTree = result;
        }
      });
    },
    setChecked(deviceId) {
      this.$refs.appDeviceGroupTree.setCheckedKeys(deviceId);
    },
  },
};
</script>
  <style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.filter_actions {
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  .height28 {
    line-height: 28px;
  }
}
/deep/.el-tree-node__content {
  height: 32px;
}
.app-area-list {
  .showIcon {
    @include set_theme_color(color, main-theme-color);
    &:hover {
      color: #fff;
    }
  }
  height: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  .search-box {
    margin-bottom: 10px;
    background: #0d121c;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    :deep .el-input__inner {
      border: none !important;
      // height: 40px;
    }
    span {
      height: 20px;
    }
    img {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
  .node {
    position: relative;
    display: flex;
    width: 100%;
    .node-cover {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &.out-line {
      color: #757373;
      .icon {
        color: #757373;
      }
    }
    .camera-type-icon {
      text-align: right;
      flex: 1;
      margin-right: 10px;
    }
  }
  .area-container {
    flex: 1;
    overflow: hidden;
    width: 100%;

    .area-node-icon {
      margin-right: 5px;
    }
    .iconfont-lunan {
      margin-right: 5px;
    }
  }
  .scroll-bar {
    height: 100%;
    z-index: 1;
    padding-bottom: 5px;
    .full-height {
      padding: 5px 0;
      /deep/.el-tree-node__content {
        height: 32px;
        &:hover {
          background: #070a0d;
        }
      }
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
      height: 100%;
      margin-bottom: 0px !important;
    }
  }
}
</style>
  
  
  